import Header from '../../../home/Header'
import Footer from '../../Footer'
import Refund from './return'

export default function index() {
  return (
    <div>
        <Header/>
        <Refund/>
        <Footer/>
    </div>
  )
}
